/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 *
 ********************************************************************!*/
import { IChat } from "@chatcaptain/types/chatbot";
import { colors } from "@/store/modules/inbox/tags";
import { ITag, ITagColor } from "@/types/inbox/tags";
import { IAnswer } from "@/types/inbox/answers";
import { ICustomView } from "@/types/inbox/views";
import { ICustomField } from "@/types/inbox/fields";
import { Unsubscribe } from "firebase/firestore";
import { IChatMessage } from "@chatcaptain/types/dist/chatbot";
import {
  IGroupResult,
  IUser,
  IUserResult,
} from "@chatcaptain/types/dist/organization";

export interface IInboxState {
  chatbotId: string;
  conversations: IChat[];
  conversationsLoading: boolean;
  currentConversationId: string | null;
  currentConversation: IChat | null;
  currentConversationLoading: boolean;
  currentConversationUnsubscribe: Unsubscribe | null;
  currentMessages: IChatMessage[] | null;
  tagColors: { [key: string]: ITagColor };
  tags: ITag[] | null;
  answers: IAnswer[] | null;
  views: ICustomView[] | null;
  fields: ICustomField[] | null;
  location: { [key: string]: IChat["location"] };
  // users: IUserResult[] | null;
  // groups: IGroupResult[] | null;
}

export const state: IInboxState = {
  chatbotId: "",
  conversations: [],
  conversationsLoading: false,
  currentConversationId: null,
  currentConversation: null,
  currentConversationLoading: false,
  currentMessages: null,
  tagColors: colors,
  tags: null,
  answers: null,
  views: null,
  fields: null,
  currentConversationUnsubscribe: null,
  location: {},
  // users: null,
  // groups: null,
};
